import React, { useState, useRef } from "react";
import axiosInstance from "../config/axiosInstance";
import API from "../config/config";
import { FaUserCircle, FaEdit } from "react-icons/fa";

const ProfilePictureUploader = ({
  driverId,
  existingImage,
  onUpdate,
  fullName,
  editable,
}) => {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(existingImage || null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setPreview(URL.createObjectURL(file));
    setUploading(true);

    try {
      const token = localStorage.getItem("adminToken");
      const formdata = new FormData();
      formdata.append("type", "profilepic");
      formdata.append("ownerId", driverId);
      formdata.append("documentFor", "Driver");
      formdata.append("file", file);

      const response = await axiosInstance.post(
        `${API.ADMIN.ADMINDOCUMENT_UPLOAD}`,
        formdata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Update driver's profileImage field
      if (response.data?.document?.documentUrl) {
        const imageUrl = response.data.document.documentUrl;
        await axiosInstance.patch(
          `${API.ADMIN.UPDATE_DRIVER}/${driverId}`,
          { profileImage: imageUrl },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (onUpdate) onUpdate(); // Refresh parent data
    } catch (err) {
      console.error("Profile image upload failed", err);
    } finally {
      setUploading(false);
    }
  };

  const triggerFileSelect = () => {
    if (!uploading && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="bg-gradient-to-r from-blue-500 to-purple-600 text-white p-6 text-center relative">
      <h1 className="text-3xl font-semibold">Driver Details</h1>
      <p className="text-lg">{fullName}</p>

      <div className="relative w-32 h-32 mx-auto mt-4">
        {preview ? (
          <img
            src={preview}
            alt="Driver Profile"
            className="w-32 h-32 rounded-full border-4 border-white shadow-md object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "";
            }}
          />
        ) : (
          <FaUserCircle className="w-32 h-32 rounded-full border-4 border-white shadow-md bg-gray-300" />
        )}

        {/* Edit icon */}
        {editable && (
          <button
            onClick={triggerFileSelect}
            className="absolute bottom-1 right-1 bg-white p-1 rounded-full shadow hover:bg-gray-100"
            title="Edit Profile Picture"
          >
            <FaEdit className="text-blue-600" />
          </button>
        )}

        {/* Hidden file input */}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          ref={fileInputRef}
          className="hidden"
        />
      </div>
    </div>
  );
};

export default ProfilePictureUploader;
